export const formatReviewDate = value => {
    if (!value)
        return 'Fecha desconocida';

    const date = new Date(value);

    if (Number.isNaN(date.getTime()))
        return 'Fecha desconocida';

    return new Intl.DateTimeFormat('es-MX', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'America/Mexico_City'
    }).format(date);
};

export const moderationReasonText = value => value || 'Otro';

export const productPath = product => {
    if (!product?.available || !product.url || !product.barcode)
        return '';

    return `/tienda/producto/${product.url}/${product.barcode}`;
};
